import React from 'react';
import { useTranslation } from 'react-i18next';

const Glossary = () => {
  const { t: translate } = useTranslation();

  // Until we implement the missing flow (Help center flow) related to DV-3804
  const allowHelpCenter = false;

  return (
    <div className="d-flex flex-column mt-3 mt-md-5 px-md-4">
      <p className="text-dark text-f3">{translate('cryptodraft_glossary_title')}</p>
      <div className="d-flex flex-column p-3 bg-info-light mt-4 rounded-extra">
        <div className="d-flex flex-row justify-content-start align-items-center">
          <i className="icon icon-info-icon text-info text-f4" aria-label="info" />
          <p className="text-f6 text-dark ps-2">{translate('cryptodraft_glossary_info_note')}</p>
        </div>
        <div className="d-flex flex-row mt-3">
          <p className="text-dark text-f6">
            <span className="text-dark text-bold pe-1">{translate('cryptodraft_glossary_1')}:</span>
            <span style={{ opacity: 0.6 }}>{translate('cryptodraft_glossary_1_description')}</span>
          </p>
        </div>
        <div className="d-flex flex-row mt-3">
          <p className="text-dark text-f6">
            <span className="text-dark text-bold pe-1">{translate('cryptodraft_glossary_2')}:</span>
            <span style={{ opacity: 0.6 }}>{translate('cryptodraft_glossary_2_description')}</span>
          </p>
        </div>
        <div className="d-flex flex-row mt-3">
          <p className="text-dark text-f6">
            <span className="text-dark text-bold pe-1">{translate('cryptodraft_glossary_3')}:</span>
            <span style={{ opacity: 0.6 }}>{translate('cryptodraft_glossary_3_description')}</span>
          </p>
        </div>
        <div className="d-flex flex-row mt-3">
          <p className="text-dark text-f6">
            <span className="text-dark text-bold pe-1">{translate('cryptodraft_glossary_4')}:</span>
            <span style={{ opacity: 0.6 }}>{translate('cryptodraft_glossary_4_description')}</span>
          </p>
        </div>
      </div>
      {allowHelpCenter && (
        <p className="text-shadow text-f5 mt-5">
          {translate('cryptodraft_glossary_have_question_1')}
          <span className="text-primary cursor-pointer text-bold">
            {translate('cryptodraft_glossary_have_question_2')}
          </span>
        </p>
      )}
    </div>
  );
};

export default Glossary;
